var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.myShow == true) ? _c('div', {
    staticClass: "notification fixed"
  }, [(_vm.myOptions.autoClose == false) ? _c('div', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n        " + _vm._s(_vm.myOptions.content) + "\n        "), (_vm.myOptions.action) ? _c('span', {
    staticClass: "action",
    on: {
      "click": function($event) {
        return _vm.action()
      }
    }
  }, [_vm._v(_vm._s(_vm.myOptions.action))]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm.myShow && _vm.myOptions.autoClose && _vm.myOptions.countdownBar) ? _c('div', {
    staticClass: "countdown",
    class: _vm.barControl,
    style: (_vm.setTime)
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56cd20de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Notifications/Notification.vue
// module id = lP/h
// module chunks = 2